import { UploadFile } from 'antd';
import React from 'react';
import { ApplicantUserNameOnDocumentAsset, FileInfo } from '../../../../generated';
import FilePreview from '../../../shared/file-preview/file-preview';
import { AuthResult, AzureBlobResponse } from '../../../shared/file-upload/azure-upload';
import { FileUploadButton } from '../../../shared/file-upload/file-upload-button';

interface ApplicantProfileIdentityUploadProps {
  isUploadProcessing?: boolean;
  nameOnDocumentAssets: ApplicantUserNameOnDocumentAsset[];
  assetUpdateFunction: (file: File) => Promise<AuthResult>;
  onAssetUpdate: (response: AzureBlobResponse, file: UploadFile) => Promise<void>;
  files: FileInfo[];
}

export const ApplicantProfileIdentityUpload: React.FC<ApplicantProfileIdentityUploadProps> = ({
  nameOnDocumentAssets,
  assetUpdateFunction,
  onAssetUpdate,
  files,
  isUploadProcessing
}) => {
  return (
    <div>
      <div className="flex w-full gap-5 flex-wrap h-auto">
        {nameOnDocumentAssets?.map((doc: ApplicantUserNameOnDocumentAsset) => (
          <FilePreview
            key={doc.id}
            fileUrl={files?.find((f) => f.name.includes(doc.documentName?.replace(/\s+/g, '-') ?? ''))?.url ?? ''}
            fileName={doc.documentName?.replace(/\s+/g, '') ?? ''}
            fileType={files?.find((f) => f.name.includes(doc.documentName?.replace(/\s+/g, '-') ?? ''))?.type ?? ''}
          />
        ))}
      </div>
      <br />
      <FileUploadButton
        authorizeRequest={assetUpdateFunction}
        permittedContentTypes={['image/jpeg', 'application/pdf']}
        permittedExtensions={['jpg', 'jpeg', 'pdf']}
        maxFileSizeBytes={10 * 1024 * 1024} // 10MB,
        maxWidthOrHeight={2048}
        onSuccess={onAssetUpdate}
        buttonText="Add Name Documentation"
        isUploadPreviewImage={false}
        isProcessing={isUploadProcessing}
      />
    </div>
  );
};
